import { type ReactElement } from 'react'
import { type GlobalError } from 'react-hook-form'

import Alert from '@mui/material/Alert'
import DialogContentText from '@mui/material/DialogContentText'

import { getGlobalErrorMessages } from 'global/helpers/form'

interface KNDialogFormErrorsProps {
  errors?: Record<string, GlobalError>
}

const KNDialogFormErrors = ({ errors }: KNDialogFormErrorsProps): ReactElement | null => {
  if (!errors) {
    return null
  }
  return (
    <DialogContentText component="div" mb={3}>
      <Alert severity="error">{getGlobalErrorMessages(errors)}</Alert>
    </DialogContentText>
  )
}

export default KNDialogFormErrors
